import { CLOSE_MODAL, OPEN_MODAL, SET_MODAL_DATA, TOGGLE_MODAL } from '@src/store/modal/modal.consts';

const mkAction = (action, payload = undefined) => ({ action, payload });

export const openModal = () => mkAction(OPEN_MODAL);
export const closeModal = () => mkAction(CLOSE_MODAL);
export const toggleModal = () => mkAction(TOGGLE_MODAL);
export const setModalData = (data) => mkAction(SET_MODAL_DATA, data);
